module.exports = __webpack_public_path__ + "img/couples-035.7684eba3.jpg";